import React from "react";

import HeaderTitle from "@src/components/shared-ui-components/HeaderTitle";

import { CustomCard } from "./style";

interface SharedCardPropsType {
  children?: React.ReactNode;
  title: string;
  dropDownOptions: dropDownOptionType[];
  selectedValue: string;
  handleTypeChange: (type: string) => void;
}

const SharedCard = (props: SharedCardPropsType) => {
  const { children, title, handleTypeChange, dropDownOptions, selectedValue } =
    props;

  return (
    <CustomCard>
      <HeaderTitle
        title={title}
        handleChange={handleTypeChange}
        value={selectedValue}
        options={dropDownOptions?.map((el) => el.label)}
      />
      {children}
    </CustomCard>
  );
};

SharedCard.defaultProps = {
  children: undefined,
};

export default SharedCard;
